import { Component, input, output, signal, viewChild, OnInit } from '@angular/core';
import { PanModalComponent } from '../../../../components/pan-modal/pan-modal.component';
import { VideoClip, WalkoutVideoClip } from 'src/app/types';

@Component({
  selector: 'app-review-clip-not-useful',
  templateUrl: './review-clip-not-useful.component.html',
  styleUrl: './review-clip-not-useful.component.scss',
  standalone: false,
})
export class ReviewClipNotUsefulComponent implements OnInit {
  public videoClip = input<VideoClip | WalkoutVideoClip>();
  public report = output<{ videoClipId: string; clipNotUsefulReason: string }>();
  public notUsefulReason = signal<string>('');
  public isNotUseful = signal(false);

  readonly reasons = [
    { value: 'too_late', label: 'Clip started too late - walked off the market' },
    { value: 'no_movement', label: 'Clip did not detect movement' },
    { value: 'mismatch', label: 'Clip does not match cancellation date and time' },
    { value: 'ended_early', label: 'Clip inconclusive - ended too early' },
  ];

  private modal = viewChild<PanModalComponent>('modal');

  onClipNotUsefulClick() {
    this.notUsefulReason.set('');
    this.modal()?.show();
  }

  ngOnInit() {
    const clip = this.videoClip();
    if (clip && 'not_useful_submitted' in clip) {
      this.isNotUseful.set(clip.not_useful_submitted);
    }
  }
  onSubmit() {
    this.report.emit({
      videoClipId: this.videoClip().id,
      clipNotUsefulReason: this.notUsefulReason(),
    });
    this.isNotUseful.set(true);
    this.notUsefulReason.set('');
    this.modal()?.hide();
  }
}
